// extracted by mini-css-extract-plugin
module.exports = {"appBoar":"AppBoar_appBoar__mgsDO","appBoar_tab":"AppBoar_appBoar_tab___Vqvt","appBoar_content":"AppBoar_appBoar_content__HPFjl","appBoar_item":"AppBoar_appBoar_item__3otPI"};